import Vue from 'vue'
import Router from 'vue-router'
import Privacy from '@/components/Privacy'
import Terms from '@/components/Terms'
import Home from '@/components/Home'
import Mypage from '@/components/Mypage'
import Schedules from '@/components/schedules/Index'
import Entry from '@/components/Entry'
import EntryLogin from '@/components/EntryLogin'
import Thanks from '@/components/Thanks'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/mypage',
      name: 'Mypage',
      component: Mypage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/schedules',
      name: 'Schedules',
      component: Schedules,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/thanks',
      name: 'Thanks',
      component: Thanks
    },
    {
      path: '/:userId',
      name: 'EntryLogin',
      component: EntryLogin
    },
    {
      path: '/:userId/entry',
      name: 'Entry',
      component: Entry,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js